import { render } from "./App.vue?vue&type=template&id=35dff9f5"
const script = {}

import "./App.vue?vue&type=style&index=0&id=35dff9f5&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__